import { Plugin } from '@nuxt/types';

const hydrationDebugPlugin: Plugin = () => {
  // Only run in development
  if (process.env.NODE_ENV === 'production') return;

  const originalConsoleError = console.error;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  console.error = (...args: any[]) => {
    const msg = args[0];
    // Detect Vue hydration mismatch errors
    if (
      typeof msg === 'string'
      && (msg.includes('The client-side rendered virtual DOM tree is not matching')
        || msg.includes('Mismatching childNodes vs. VNodes'))
    ) {
      // eslint-disable-next-line no-console
      console.warn('⚠️ Hydration Mismatch Detected! Pausing execution.');
      // eslint-disable-next-line no-console
      console.log(
        'Check the "Elements" tab to see the difference between server HTML and client VDOM.',
      );

      // Pause execution to inspect the DOM state at the moment of mismatch
      // eslint-disable-next-line no-debugger
      debugger;
    }

    originalConsoleError(...args);
  };

  // eslint-disable-next-line no-console
  console.log('[HYDRATION DEBUG] Plugin active. Watching for mismatches...');
};

export default hydrationDebugPlugin;
